import { call, takeLatest, put } from 'redux-saga/effects'
import graphql from 'services/graphql'
import { errorMessageFromGraphQL } from 'config/toast'
import {
  FAILED_GET_ROLE,
  FAILED_GET_ROLES,
  RECEIVE_GET_ROLE,
  RECEIVE_GET_ROLES,
  REQUEST_GET_ROLE,
  REQUEST_GET_ROLES,
} from 'redux/actions/role'
import { NOTIFY } from 'redux/actions/notification'
import { ROLE_QUERY, ROLES_QUERY } from 'graphql/queries/role'

function* getRole(action) {
  try {
    const data = yield call(graphql.query, ROLE_QUERY, { id: action.id })

    yield put({ type: RECEIVE_GET_ROLE, data: data.roles[0] })
  } catch (error) {
    yield put({ type: FAILED_GET_ROLE, error })

    const notification = yield errorMessageFromGraphQL(error)
    yield put({ type: NOTIFY, notification })
  }
}

function* getRoles(action) {
  try {
    const data = yield call(graphql.query, ROLES_QUERY, {
      // pageNumber: action.pageNumber,
      // pageSize: action.pageSize,
      // ...action.filters,
      // ...(action.sorting ? { sorting: action.sorting } : {})
    })

    yield put({ type: RECEIVE_GET_ROLES, data: data.roles })
  } catch (error) {
    yield put({ type: FAILED_GET_ROLES, error })

    const notification = yield errorMessageFromGraphQL(error)
    yield put({ type: NOTIFY, notification })
  }
}

export default function* root() {
  yield takeLatest(REQUEST_GET_ROLE, getRole)
  yield takeLatest(REQUEST_GET_ROLES, getRoles)
}
